import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import SocialIcons from "@/components/SocialIcons";

const Footer = () => {
  return (
    <footer className="bg-secondary py-12 border-t border-marble/10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-2">
              <img src="/logo.png" alt="حسن عبدالله للمقاولات والديكورات" className="w-12 h-12 object-contain" loading="lazy" width={48} height={48} />
              <span className="text-lg font-bold gold-text">حسن عبدالله للمقاولات والديكورات</span>
            </div>
            <p className="text-marble/50 text-sm mt-3 leading-relaxed">
              خبراء التصميم الداخلي والترميم والمقاولات في الرياض — جودة واحترافية تتجاوز التوقعات
            </p>
            <div className="mt-4">
              <SocialIcons size="md" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-marble font-bold mb-4">روابط سريعة</h3>
            <nav className="flex flex-col gap-2" aria-label="روابط الموقع">
              <Link to="/" className="text-marble/50 hover:text-primary transition-colors text-sm">الرئيسية</Link>
              <Link to="/services" className="text-marble/50 hover:text-primary transition-colors text-sm">خدماتنا</Link>
              <Link to="/gallery" className="text-marble/50 hover:text-primary transition-colors text-sm">أعمالنا</Link>
              <Link to="/about" className="text-marble/50 hover:text-primary transition-colors text-sm">من نحن</Link>
              <Link to="/contact" className="text-marble/50 hover:text-primary transition-colors text-sm">تواصل معنا</Link>
              <Link to="/blog" className="text-marble/50 hover:text-primary transition-colors text-sm">المدونة</Link>
            </nav>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-marble font-bold mb-4">خدماتنا</h3>
            <nav className="flex flex-col gap-2" aria-label="روابط الخدمات">
              <Link to="/services/decorations-riyadh" className="text-marble/50 hover:text-primary transition-colors text-sm">ديكورات وتصميم داخلي</Link>
              <Link to="/services/paint-riyadh" className="text-marble/50 hover:text-primary transition-colors text-sm">دهانات وورق جدران</Link>
              <Link to="/services/gypsum-riyadh" className="text-marble/50 hover:text-primary transition-colors text-sm">أعمال الجبس بورد</Link>
              <Link to="/services/parquet-riyadh" className="text-marble/50 hover:text-primary transition-colors text-sm">تركيب باركيه</Link>
              <Link to="/services/wallpaper-riyadh" className="text-marble/50 hover:text-primary transition-colors text-sm">ورق جدران</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-marble font-bold mb-4">تواصل معنا</h3>
            <div className="flex flex-col gap-3">
              <a href="tel:0556641963" className="flex items-center gap-2 text-marble/50 hover:text-primary transition-colors text-sm" dir="ltr">
                <Phone className="w-4 h-4" />
                0556641963
              </a>
              <a href="tel:0534859731" className="flex items-center gap-2 text-marble/50 hover:text-primary transition-colors text-sm" dir="ltr">
                <Phone className="w-4 h-4" />
                0534859731
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-marble/10 pt-6 text-center">
          <p className="text-marble/50 text-sm">
            جميع الحقوق محفوظة © {new Date().getFullYear()} حسن عبدالله للمقاولات والديكورات
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
